import { gql } from "@apollo/client";

interface CurrentMemberWithChange {
  primaryEmail: string;
  pendingEmailChange?: { isExpired: boolean; email: string };
}

export interface Query {
  currentMember: CurrentMemberWithChange;
}

export const PENDING_EMAIL_CHANGE_FRAGMENT = gql`
  fragment PendingEmailChangeFragment on MembershipMember {
    id: memberNumber
    primaryEmail
    pendingEmailChange {
      id
      email
      isExpired
    }
  }
`;

export const INITIATE_MUTATION = gql`
  mutation InitiateEmailChange($email: String!) {
    initiateEmailChange(email: $email) {
      message
      success
      currentMember {
        ...PendingEmailChangeFragment
      }
    }
  }
  ${PENDING_EMAIL_CHANGE_FRAGMENT}
`;

export interface InitiateMutation {
  initiateEmailChange: {
    success: boolean;
    message: string;
    currentMember: CurrentMemberWithChange;
  };
}

export const QUERY = gql`
  query GetCurrentMemberEmailChangeStatus {
    currentMember {
      ...PendingEmailChangeFragment
    }
  }
  ${PENDING_EMAIL_CHANGE_FRAGMENT}
`;
